import React from 'react';

import Field, { hasDataInFields } from '../../containers/PageBuilder/Field';
import SectionContainer from '../../containers/PageBuilder/SectionBuilder/SectionContainer';
import { ExternalLink } from '../../components';

import { angaben, BETREIBER, EYEBROW, fehlendeAngaben, LEAD, ODR } from '../imprint';
import gem from '../salesPage.module.css';
import css from './SectionImprint.module.css';

/**
 * FairwayBid: Impressum.
 *
 * Vorher ein Block Fließtext aus der Console, in dem Anschrift, Register und
 * Kontakt in einer Zeile hintereinander standen. Ein Impressum wird aber
 * nicht gelesen, sondern nachgeschlagen: Jemand sucht eine Angabe und will
 * sie finden, ohne den Rest zu lesen. Deshalb steht hier eine Liste aus
 * Begriff und Wert und kein Absatz.
 *
 * Die Überschrift kommt weiter aus der Console, die Angaben aus imprint.js.
 * Angaben, die dort fehlen, werden weggelassen und unten benannt – lieber
 * eine sichtbare Lücke als eine Registernummer, die einer anderen Firma
 * gehört.
 */
const SectionImprint = props => {
  const { sectionId, className, rootClassName, title, appearance, callToAction, options } = props;

  const fieldComponents = options?.fieldComponents;
  const fieldOptions = { fieldComponents };
  const hasHeaderFields = hasDataInFields([title, callToAction], fieldOptions);

  const zeilen = angaben();
  const offen = fehlendeAngaben();

  return (
    <SectionContainer
      id={sectionId}
      className={className}
      rootClassName={rootClassName}
      appearance={appearance}
      options={fieldOptions}
    >
      {hasHeaderFields ? (
        <header className={gem.header}>
          <span className={gem.eyebrow}>{EYEBROW}</span>
          <Field data={title} className={gem.headTitle} options={fieldOptions} />
          <span className={gem.rule} aria-hidden="true" />
          <p className={gem.intro}>{LEAD}</p>
        </header>
      ) : null}

      <div className={gem.wrap}>
        <div className={css.karte}>
          <p className={css.betreiberLabel}>Betreiberin der Plattform</p>
          <p className={css.betreiber}>{BETREIBER.name}</p>

          {/*
            Begriff und Wert als Beschreibungsliste - nicht als Tabelle.
            Es sind Paare, keine Matrix, und auf dem Telefon stehen sie
            deshalb untereinander, ohne dass etwas quer laufen muss.
          */}
          <dl className={css.angaben}>
            {zeilen.map(z => (
              <div key={z.begriff} className={css.zeile}>
                <dt className={css.begriff}>{z.begriff}</dt>
                <dd className={css.wert}>
                  {z.mailto ? (
                    <a className={css.mail} href={`mailto:${z.mailto}`}>
                      {z.mailto}
                    </a>
                  ) : (
                    z.wert.map(t => <span key={t}>{t}</span>)
                  )}
                </dd>
              </div>
            ))}
          </dl>

          {offen.length > 0 ? (
            <p className={css.offen}>
              {offen.join(' und ')} {offen.length > 1 ? 'werden' : 'wird'} ergänzt.
            </p>
          ) : null}
        </div>

        <section className={css.odr}>
          <h2 className={css.odrTitel}>{ODR.titel}</h2>
          <p className={css.odrText}>
            {ODR.text}{' '}
            <ExternalLink href={ODR.linkUrl} className={css.odrLink}>
              {ODR.linkText}
            </ExternalLink>
          </p>
        </section>
      </div>
    </SectionContainer>
  );
};

export default SectionImprint;
